import client from "./client";

// Both admin-only, enforced server-side.
export const toggleAdminRole = (userId) => client.put(`/admin/assign/${userId}`);
export const createUser = (userData) =>
  client.post("/admin/users", userData);

// Adds (or invites, if the email doesn't match an existing account) a member
// to a community by email — this is also how a pending join request is
// approved: the community gets a new member and the matching request is
// marked accepted.
export const addMemberToCommunity = (communityId, email) =>
  client.post(`/admin/addtocommunity/${communityId}`, { email });
